/**
 * Auto Reveal — applies the site-wide scroll-reveal system to ordinary
 * theme sections automatically, without needing to hand-edit each one.
 *
 * Sections built specifically for this project (header, hero, product
 * carousel) already have their own bespoke, more detailed reveal treatment
 * and are skipped here so they aren't double-animated. Every other section
 * Shopify renders gets a simple fade-up-into-view as a whole block — a
 * safe, universal treatment that works regardless of what's inside a given
 * section, since this script has no way to know each section's internal
 * markup ahead of time.
 *
 * Must run BEFORE scroll-reveal.js so the [data-reveal] attributes this
 * script adds are already in place when that script does its one-time
 * element scan. In the header file, this script's tag is placed first.
 */
(function () {
  document.querySelectorAll('.shopify-section').forEach(function (section) {
    // Skip sections with their own bespoke animation (header/hero/carousel),
    // and skip anything that already opted itself into the reveal system.
    if (section.querySelector('.mh, .hs, .pc')) return;
    if (section.hasAttribute('data-reveal') || section.querySelector('[data-reveal]')) return;
    // Skip the footer specifically — a footer fading in/out of view as you
    // scroll near the bottom of the page reads as a bug, not a feature.
    if (section.querySelector('footer')) return;

    section.setAttribute('data-reveal', 'fade-up');
    section.style.setProperty('--reveal-distance', '2.5rem');
  });
})();
